// @need-translate
import {t} from '../../../common/getTranslations';
import {stopPropagationEvent} from '../../../common/shared/utils/stopPropagationEvent.function';
import {twMerge} from '../../../common/twMerge';
import {OnIssue} from '../../../graphql/generated/types';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Image} from '../../atoms/Image/Image';
import {Text} from '../../atoms/Text/Text';
import {ThumbnailRatio} from '../../molecules/ThumbnailWithBadges/ThumbnailRatio.constant';
import {ThumbnailType} from '../../molecules/ThumbnailWithBadges/ThumbnailType.enum';
import {ViewerEndNextItemProps} from './ViewerEndNextItemProps.interface';

export function ViewerEndNextItem({
  isVideoViewer = false,
  nextItem,
  onIssue,
  onClickNextItem = () => {},
  isSaleStateStop = false,
  isMobile,
  className,
  ...props
}: ViewerEndNextItemProps) {
  return (
    <div className={twMerge(isMobile && 'h-80pxr rounded-8pxr', className)}>
      {nextItem ? (
        <div
          className={twMerge(
            'flex cursor-pointer items-center',
            isMobile && 'space-x-14pxr',
            !isMobile && 'h-108pxr space-x-12pxr py-14pxr pr-24pxr pl-32pxr'
          )}
          onClick={e => {
            stopPropagationEvent(e);
            onClickNextItem(e);
          }}
          {...props}
        >
          <div className="relative h-full w-56pxr shrink-0">
            <Image
              src={nextItem.thumbnail}
              ratio={ThumbnailRatio[ThumbnailType.Poster]}
              alt={'작품 썸네일'}
              className="h-full w-full overflow-hidden rounded-8pxr"
            />
            {isVideoViewer && (
              <div className="absolute right-4pxr bottom-4pxr">
                <Icon
                  type={IconType.PlayerPlaySolidStatic}
                  disableActiveEffect
                ></Icon>
              </div>
            )}
            {/* 썸네일 보더 */}
            <div className="absolute top-0 left-0 h-full w-full rounded-8pxr border-[0.5px] border-solid border-static-transparent-black-05" />
          </div>

          <div className="w-full">
            <div className="flex">
              <Text className="font-medium2-bold text-theme-solid-100">
                {nextItem.isHidden
                  ? t('viewer_end_next_ea_ep_button')
                  : nextItem.isFree
                    ? t('viewer_end_next_free_ep_button')
                    : t('viewer_end_next_ep_button')}
              </Text>
            </div>
            <div className="flex pt-4pxr">
              <Text className="font-small1 text-theme-solid-40 line-clamp-1">
                {nextItem.title}
              </Text>
            </div>
            {nextItem.isHidden && nextItem.remainText && (
              <div className="flex pt-10pxr">
                <Text className="font-small1 text-theme-solid-60">
                  {nextItem.remainText}
                </Text>
              </div>
            )}
          </div>
          <div className={twMerge('shrink-0', isMobile && 'pr-12pxr')}>
            <Icon
              className="h-24pxr w-24pxr"
              type={IconType.ListArrowRight}
              disableActiveEffect
            />
          </div>
        </div>
      ) : (
        <div
          className={twMerge(
            'flex flex-col items-center justify-center',
            isMobile && 'h-80pxr rounded-[8px]',
            !isMobile && 'h-108pxr bg-theme-bg-surface-alt'
          )}
          {...props}
        >
          {/* 판매중지가 아닐 때 다음화가 없을 때의 처리 */}
          {!isSaleStateStop &&
            (onIssue === OnIssue.End ? (
              <>
                <Text className="font-medium2-bold text-theme-solid-100">
                  {t('viewer_menu_completed')}
                </Text>
                <Text className="font-small2 mt-4pxr text-theme-solid-40">
                  {t('viewer_end_recommend_contents_info')}
                </Text>
              </>
            ) : (
              <>
                <Text className="font-medium2-bold text-theme-solid-100">
                  {t('viewer_menu_last_episode')}
                </Text>
                <Text className="font-small2 mt-4pxr text-theme-solid-40">
                  {t('viewer_end_last_ep')}
                </Text>
              </>
            ))}
          {/* 판매중지가 일때 다음화가 없을 때의 처리 */}
          {isSaleStateStop && (
            <Text className="font-medium2-bold text-theme-solid-100">
              다음화가 없습니다.
            </Text>
          )}
        </div>
      )}
    </div>
  );
}
